export default {
  title: 'Articles populaires',
  list: {
    empty_list: {
      title: "Aucun article populaire pour l'instant.",
    },
    fields: {
      name: 'Nom',
      orders: 'Commandes',
      sales: 'Ventes',
    },
  },
};
